import * as Sentry from "@sentry/react";
import { buildTracePropagationTargets } from "./tracePropagationTargets";

interface SentryUser {
  id: string;
  username?: string;
  email?: string;
}

const sentryDsn = import.meta.env.VITE_SENTRY_DSN || "";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: buildTracePropagationTargets({
      VITE_GENERATOR_API_URL: import.meta.env.VITE_GENERATOR_API_URL,
      VITE_AGREEMENTS_API_URL: import.meta.env.VITE_AGREEMENTS_API_URL,
      VITE_FATURAMENTO_API_URL: import.meta.env.VITE_FATURAMENTO_API_URL,
      VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    }),
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });

  window.onerror = (message, source, lineno, colno, error) => {
    Sentry.captureException(error || message);
  };

  window.onunhandledrejection = (event) => {
    Sentry.captureException(event.reason);
  };
}

export const setUserInSentry = (user: SentryUser) => {
  Sentry.setUser({
    id: user.id,
    username: user.username,
    email: user?.email,
  });
};

export const clearUserInSentry = () => {
  Sentry.setUser(null);
};

export const setTagInSentry = (tag: string, value: string) => {
  Sentry.setTag(tag, value);
};

export const captureMessage = (
  message: string,
  level?: Sentry.SeverityLevel,
  extra?: Record<string, unknown>,
) => {
  Sentry.captureMessage(message, { level, extra });
};

export const captureException = (
  error: Error | unknown,
  extra?: Record<string, unknown>,
) => {
  Sentry.captureException(error, { extra });
};

export default Sentry;
